import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { ClosingSections } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsAndProof data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOffer data-id="element-5" />
      <Pricing data-id="element-6" />
      <ClosingSections data-id="element-7" />
    </main>;
}